import { createFileRoute } from "@tanstack/react-router";

import { routeHead } from "@/lib/seo-head";
import Prestations from "@/pages/Prestations";

export const Route = createFileRoute("/prestations")({
  head: () =>
    routeHead({
      path: '/prestations',
      title: 'Prestations et tarifs | JIIA Studio Lyon',
      description: "Architecture d'intérieur, images 3D, conseil couleurs, fresques murales et conseils achat immobilier. Tarifs de départ et premier rendez-vous offert.",
    }),
  component: Prestations,
});
